module.exports = __webpack_public_path__ + "img/Frame 1090two.3ebc926c.png";